import { useState } from "react";
import { useOrganisationRecord } from "@/app/Organisations/Hooks/useOrganisationRecord";
import { Navbar, NavbarItem } from "@/components/catalyst/navbar";
import { OrganisationMembersTable } from "@/app/Organisations/Components/OrganisationMembersTable";
import { OrganisationInvitationsTable } from "@/app/Organisations/Components/OrganisationInvitationsTable";

export function OrganisationMembersScreen() {
  const record = useOrganisationRecord();
  const [activeTab, setActiveTab] = useState<"members" | "invitations">(
    "members",
  );
  return (
    <div className="py-6">
      <div className="mb-4">
        <Navbar>
          <NavbarItem
            current={activeTab === "members"}
            onClick={() => setActiveTab("members")}
          >
            Members
          </NavbarItem>
          <NavbarItem
            current={activeTab === "invitations"}
            onClick={() => setActiveTab("invitations")}
          >
            Invitations
          </NavbarItem>
        </Navbar>
      </div>

      {activeTab === "members" ? (
        <OrganisationMembersTable organisationId={record.id} />
      ) : (
        <OrganisationInvitationsTable organisationId={record.id} />
      )}
    </div>
  );
}
